import script from "./couponConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./couponConfig.vue?vue&type=script&setup=true&lang=js"

import "./couponConfig.vue?vue&type=style&index=0&id=7e35ab5a&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e35ab5a"]])

export default __exports__